/**
 * Segmented — filtro de chips.
 *
 *   options: [{ value, label, dot? }]
 *   value, onChange
 *   tone: 'gray' (default, estilo Salonika: beige + pill blanco)
 *       | 'green' (handoff "Componentes.dc" #12/#37: fondo tinte verde
 *                  + pill activo verde primario con texto blanco)
 *   size: 'md' | 'sm'
 */
import { cn } from '@/lib/utils'

// Paleta por tono. El default ('gray') conserva el look previo para no
// alterar Reports/Returns/Partners; 'green' replica los chips del handoff.
const TONES = {
  gray: {
    track: '#ECEDEA',
    active: { background: '#FFFFFF', color: '#15321F', fontWeight: 700, boxShadow: '0 2px 6px rgba(20,80,42,0.10)' },
    inactive: { background: 'transparent', color: '#7A8A7E', fontWeight: 700 },
  },
  green: {
    track: '#E3F0D5',
    active: { background: '#1E6E3A', color: '#FFFFFF', fontWeight: 700, boxShadow: '0 4px 10px rgba(30,110,58,0.28)' },
    inactive: { background: 'transparent', color: '#4F7458', fontWeight: 700 },
  },
}

export function Segmented({ options, value, onChange, className, size = 'md', tone = 'gray' }) {
  const pad = size === 'sm' ? 'px-3 py-1.5 text-sm' : 'px-4 py-2 text-[15px]'
  const t = TONES[tone] || TONES.gray
  return (
    <div
      className={cn('inline-flex items-center gap-1 rounded-full', className)}
      style={{ background: t.track, padding: '6px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}
    >
      {options.map((o) => {
        const active = o.value === value
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange?.(o.value)}
            className={cn(
              'inline-flex items-center gap-2 rounded-full press transition-colors whitespace-nowrap',
              pad,
            )}
            style={active ? t.active : t.inactive}
          >
            {o.dot ? (
              <span className="w-2 h-2 rounded-full flex-none" style={{ background: o.dot }} />
            ) : null}
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
